import React from 'react';

const AppBackground = () => (
  <div className="app-bg" aria-hidden="true">
    <div className="blob blob-1" />
    <div className="blob blob-2" />
    <div className="blob blob-3" />
    <div className="grid-overlay" />
  </div>
);

export default AppBackground;